(() => {
  if (window.__txLocalConversionBound) return;
  window.__txLocalConversionBound = true;

  const classify = (link, url) => {
    if (link.dataset.txAction) return link.dataset.txAction;
    if (url.protocol === 'tel:') return 'phone_click';
    if (url.pathname === '/pages/book-mattress-fitting') return 'fitting_request_click';
    if (url.hostname.includes('google.com') && (url.pathname.includes('/maps') || url.searchParams.has('cid'))) {
      return 'directions_click';
    }
    if (url.pathname === '/pages/stores-magnolia-texas') return 'magnolia_showroom_click';
    if (url.pathname === '/pages/larry-heilers') return 'larry_profile_click';
    if (url.pathname.startsWith('/products/')) return 'product_click';
    if (url.pathname.startsWith('/collections/')) return 'collection_click';
    return '';
  };

  document.addEventListener('click', event => {
    const link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;

    let url;
    try {
      url = new URL(link.href, window.location.origin);
    } catch (_) {
      return;
    }

    const action = classify(link, url);
    if (!action) return;

    const module = link.closest('[data-tx-module]');
    const payload = {
      event: 'tx_local_conversion',
      tx_action: action,
      tx_showroom: link.dataset.txShowroom || (url.pathname.includes('magnolia') ? 'Magnolia' : ''),
      tx_source: link.dataset.txSource || (module && module.dataset.txModule) || 'page',
      tx_page_path: window.location.pathname,
      tx_destination: url.origin === window.location.origin ? url.pathname : url.hostname
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('tx_local_conversion', payload);
      }
    } catch (_) {}

    window.dispatchEvent(new CustomEvent('tx:local-conversion', { detail: payload }));
  }, true);
})();

